module.exports = "/../../dist/frontend/images/agency-pin-pro.png?568a7e34616e87ceb24a5287e7bb172e";